var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    { staticClass: "navbar", attrs: { mode: "horizontal" } },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { toggleClick: _vm.toggleSideBar, isActive: _vm.sidebar.opened }
      }),
      _vm._v(" "),
      _c("breadcrumb"),
      _vm._v(" "),
      _c(
        "el-dropdown",
        {
          staticClass: "avatar-container",
          attrs: { trigger: "click" },
          on: {
            "visible-change": function(res) {
              return (_vm.isOpen = res)
            }
          }
        },
        [
          _c("div", { staticClass: "avatar-wrapper" }, [
            _c("img", {
              staticClass: "user-avatar",
              attrs: { src: _vm.avatar ? _vm.avatar : _vm.defaultAvatar },
              on: {
                error: function() {
                  return (_vm.avatar = _vm.defaultAvatar)
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "userName" }, [_vm._v(_vm._s(_vm.name))]),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon--right",
              class: _vm.isOpen ? "el-icon-arrow-up" : "el-icon-arrow-down"
            })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            {
              staticClass: "user-dropdown",
              attrs: { slot: "dropdown" },
              slot: "dropdown"
            },
            [
              _c("el-dropdown-item", [
                _c(
                  "span",
                  {
                    staticStyle: { display: "block" },
                    on: { click: _vm.logout }
                  },
                  [_vm._v("退出")]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-797e31be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797e31be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Navbar.vue
// module id = null
// module chunks = 